<script setup lang="ts">
import { Finished, Search } from "@element-plus/icons-vue"
import { computed, ref } from "vue"
import { useRouter } from "vue-router"
import { usePermissionStore } from "@/store/modules/permission"
import { getStoreDirectoryEntries } from "@/utils/storeNavigation"

const permission = usePermissionStore()
const router = useRouter()
const visible = ref(false)
const keyword = ref("")
const entries = computed(() => getStoreDirectoryEntries(permission.dynamicRoutes).filter(item => item.keywords.includes(keyword.value.trim())))
const open = async (path: string) => {
  visible.value = false
  await router.push(path)
}
</script>

<template>
  <div class="store-navigation-tools">
    <el-button text :icon="Search" aria-label="找功能" title="找功能" @click="visible = true"><span class="store-navigation-tools__label">找功能</span></el-button>
    <el-button v-if="permission.hasRouteName('AccessibleOperationApprovalTickets')" text :icon="Finished" aria-label="操作审核" title="操作审核" @click="open('/operation-approval/index')"><span class="store-navigation-tools__label">操作审核</span></el-button>
    <el-dialog v-model="visible" title="查找功能" width="min(680px, 92vw)" append-to-body destroy-on-close>
      <el-input v-model="keyword" :prefix-icon="Search" clearable placeholder="输入功能名称，也支持原菜单名称" aria-label="搜索功能" />
      <div class="store-navigation-tools__results">
        <button v-for="item in entries" :key="item.path" @click="open(item.path)">
          <strong>{{ item.title }}</strong><span>{{ item.group }}</span>
        </button>
        <el-empty v-if="!entries.length" description="没有找到可用功能，试试其他名称" />
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.store-navigation-tools {
  display: flex;
  align-items: center;

  .el-button + .el-button {
    margin-left: 0;
  }

  &__results {
    max-height: 55vh;
    margin-top: 16px;
    overflow: auto;
  }

  &__results button {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    padding: 14px;
    font: inherit;
    color: var(--el-text-color-primary);
    text-align: left;
    cursor: pointer;
    background: var(--el-bg-color);
    border: 0;
    border-bottom: 1px solid var(--el-border-color-lighter);
  }

  &__results button:hover, &__results button:focus-visible {
    background: var(--el-color-primary-light-9);
  }

  &__results span {
    font-size: 12px;
    color: var(--el-text-color-secondary);
  }
}

@media (max-width: 1280px) {
  .store-navigation-tools__label {
    display: none;
  }

  .store-navigation-tools :deep(.el-button > span) {
    margin-left: 0;
  }
}
</style>
